import React, { useState } from 'react';
import {
  DialogTitle, DialogContent, DialogActions,
  TextField, Button, IconButton, Typography, Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import MobileSheet from './common/MobileSheet';

const API = process.env.REACT_APP_API_BASE_URL;

export default function CompetitorModal({ open, onClose, onSuccess, onCompetitorAdded }) {
  const [name, setName]     = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const forwardSuccess = (data) => {
    if (typeof onSuccess === 'function') {
      onSuccess(data);
    }
    if (typeof onCompetitorAdded === 'function') {
      onCompetitorAdded(data);
    }
  };

  const handleSave = async () => {
    if (!name.trim()) {
      setError('Name is required');
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/api/scrapers/competitors`, { name });
      forwardSuccess(data);
      setName('');
      setError('');
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MobileSheet open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>
        New Competitor
        <IconButton onClick={onClose} aria-label="Close" sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {error && (
          <Box mb={2}>
            <Typography color="error">{error}</Typography>
          </Box>
        )}
        <TextField
          label="Competitor Name"
          fullWidth
          value={name}
          disabled={loading}
          onChange={e => setName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={loading}>
          {loading ? 'Creating…' : 'Create'}
        </Button>
      </DialogActions>
    </MobileSheet>
  );
}
